try {
  require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
import { jsx, jsxs } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { Icon } from '@design-system/icon';
import { Modal } from '@design-system/modal';
import classNames from 'classnames';
import { forwardRef } from 'react';
var Dialog = forwardRef(function (_ref) {
  var className = _ref.className,
    isShowing = _ref.isShowing,
    close = _ref.close,
    closeModal = _ref.closeModal,
    disableOnClickClose = _ref.disableOnClickClose,
    dialogAriaLabel = _ref.dialogAriaLabel,
    titleContent = _ref.titleContent,
    data = _ref.data,
    _ref$closeAriaLabel = _ref.closeAriaLabel,
    closeAriaLabel = _ref$closeAriaLabel === void 0 ? 'close' : _ref$closeAriaLabel,
    primaryButtonLabel = _ref.primaryButtonLabel,
    primaryButtonAriaLabel = _ref.primaryButtonAriaLabel,
    secondaryButtonLabel = _ref.secondaryButtonLabel,
    secondaryButtonAriaLabel = _ref.secondaryButtonAriaLabel,
    _ref$closeIconSize = _ref.closeIconSize,
    closeIconSize = _ref$closeIconSize === void 0 ? 'large' : _ref$closeIconSize,
    onPrimaryButtonClick = _ref.onPrimaryButtonClick,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    _ref$showOverlay = _ref.showOverlay,
    showOverlay = _ref$showOverlay === void 0 ? true : _ref$showOverlay,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    _ref$iconType = _ref.iconType,
    iconType = _ref$iconType === void 0 ? 'tooltip' : _ref$iconType,
    containerElement = _ref.containerElement;
  var actionButtonData = [];
  if (primaryButtonLabel) {
    actionButtonData.push({
      elementType: 'button',
      variant: 'primary',
      size: 'large',
      children: primaryButtonLabel,
      className: 'cds-dialog-window__button',
      onClick: onPrimaryButtonClick,
      'aria-label': primaryButtonAriaLabel
    });
  }
  if (secondaryButtonLabel) {
    actionButtonData.push({
      elementType: 'button',
      variant: 'secondary',
      size: 'large',
      onClick: closeModal,
      children: secondaryButtonLabel,
      className: 'cds-dialog-window__button',
      'aria-label': secondaryButtonAriaLabel
    });
  }
  return jsx(Modal, Object.assign({
    isShowing: isShowing,
    close: close,
    disableOnClickClose: disableOnClickClose,
    className: classNames('cds-dialog-window', className, {
      'cds-dialog-window__inverse': mode !== 'default'
    }),
    ariaLabel: dialogAriaLabel,
    showOverlay: showOverlay,
    closeModal: closeModal,
    closeIconSize: closeIconSize,
    showCloseButton: showCloseButton,
    closeAriaLabel: closeAriaLabel,
    containerElement: containerElement,
    topElements: titleContent
  }, {
    children: jsxs("div", Object.assign({
      className: "cds-dialog-window__content"
    }, {
      children: [showIcon ? jsx("div", Object.assign({
        className: "cds-dialog-window__icon-container"
      }, {
        children: jsx(Icon, {
          size: 32,
          className: "cds-dialog-window__icon",
          icon: iconType
        })
      })) : null, data && jsx("div", Object.assign({
        className: "cds-dialog-window__data"
      }, {
        children: data
      })), actionButtonData.length > 0 ? jsx("div", Object.assign({
        className: classNames('cds-dialog-window__button-container')
      }, {
        children: jsx(CtaBlock, {
          data: actionButtonData
        })
      })) : null]
    }))
  }));
});
export { Dialog };